import {object, string} from 'yup'

export const itemSchema = object({
    nameEng: string().required('required'),
    nameHeb: string().required('required'),
})
